<template>
  <div class="container">
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="200px"
    >
      <el-form-item label="话术模式：" label-width="200px" prop="version">
        <el-select v-model="formData.mode" placeholder="话术模式">
					<el-option label="智能模式" value="0"></el-option>
          <el-option label="节点话术模式" value="1"></el-option>
          <el-option label="通用话术模式" value="2"></el-option>
				</el-select>
        <span>（当前模式：{{ currentMode }}）</span>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm()"
          style="margin-left: 215px"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<!-- 0 : 智能模式
1 : 节点话术模式
2 : 通用话术模式 -->
<script>
export default {
  data() {
    return {
      formData: {
        mode: undefined,
      },
      currentMode: "",
    };
  },
  mounted() {
    this.getMode();
  },
  methods: {
    submitForm() {
      this.updateMode();
    },
    async getMode() {
      var api = "/manager/multiModeUtter/selectCurrMode";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (res.resultCode == 10000) {
        //this.formData.mode = res.data;
        if(res.data == 0){
          this.currentMode = '智能模式';
        }else if(res.data == 1){
          this.currentMode = '节点话术模式';
        }else{
          this.currentMode = '通用话术模式';
        }
      } else {
        this.$message.error(res.desc);
      }
    },

    async updateMode() {
      var api = "/manager/multiModeUtter/setMode";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          mode: this.formData.mode,
        },
      });
      if (res.resultCode == 10000) {
        this.formData.mode= undefined
        this.getMode();
        this.$message.success("修改配置成功！")
      } else {
        this.$message.error(res.desc);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
}
::v-deep .el-form {
  width: 600px;
  margin: 0 auto;
  .el-form-item {
    display: flex;
    align-items: center;
    // justify-content: center;
    .el-form-item__content {
      display: flex;
      margin-left: 0 !important;
    }
    .el-form-item__label {
      padding: 0;
    }
  }
}
::v-deep  .el-input {
  width: auto;
  margin: 0 10px 0 0;
  .el-input__inner {
    width: 100px;
    height: 34px;
  }
}
</style>
